module.exports = __webpack_public_path__ + "img/zjw.3d60d5d0.png";